import { render, staticRenderFns } from "./ModalBaixa.vue?vue&type=template&id=0b10921c"
import script from "./ModalBaixa.vue?vue&type=script&lang=js"
export * from "./ModalBaixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports